const CreateticketButtonSection = (props) => {
  return (
    <div className="event-tickets-empty">
      <div className="event-tickets-empty-icon" aria-hidden="true">
        <i className="bi bi-ticket-perforated"></i>
      </div>
      <h2 className="event-tickets-empty-title">Let&apos;s Create Tickets</h2>
      <p className="event-tickets-empty-text">
        Create multiple tickets for your event.
      </p>
      <button
        type="button"
        className="event-tickets-empty-btn"
        onClick={props.ButtonClickHandler}
        disabled={props?.isLoading}
      >
        Create Ticket
      </button>
    </div>
  );
};
export default CreateticketButtonSection;
